import React from 'react';

const LocationsIcon = (props) => {
  let { 
    height, 
    width, 
    iconColor,
  } = props;
  
  return (
    <svg 
      width={width ? width : '19px'} 
      height={height ? height : '21px'} 
      viewBox="0 0 24 26" 
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>Plan of Record</title>
      <g fill="#ffffff" fillRule="nonzero">
        <path fill={iconColor} d="M21.502 2h-17a2.5 2.5 0 0 0-2.45 2h-.05v18.97h.05c-.02.08-.03.17-.04.26a2.507 
          2.507 0 0 0 2.49 2.75h16c.28 0 .5-.22.5-.5v-3.5h.5c.28 0 .5-.22.5-.5V2.51c0-.29-.22-.51-.5-.51zm-1.5 
          20.97h-14v1h14v1h-15.5a1.493 1.493 0 0 1-1.49-1.65c.07-.76.77-1.35 1.58-1.35h15.41v1zm1-2H4.592c-.59 
          0-1.14.2-1.59.53v-17c0-.83.67-1.5 1.5-1.5h16.5v17.97z"/>
        <g stroke={iconColor}>
            <path d="M12.29 18.562zm-.17-.145a21.86 21.86 0 0 0 2.266-2.594c1.136-1.52 1.932-3.01 
            2.241-4.379.093-.409.14-.802.14-1.178 0-2.726-1.988-4.766-4.634-4.766C9.487 5.5 7.5 7.541 7.5 10.272c0 
            1.807.857 3.726 2.303 5.622a18.197 18.197 0 0 0 2.318 2.523z"/>
            <path d="M12.133 11.967c1.01 0 1.834-.824 1.834-1.834 0-1.01-.824-1.833-1.834-1.833-1.01 0-1.833.824-1.833 
            1.833 0 1.01.824 1.834 1.833 1.834z"
            />
        </g>
    </g>
    </svg>
  );
};

export default LocationsIcon;



// WEBPACK FOOTER //
// ./src/components/Iconoclast/LocationsIcon/index.js